export const VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  GHOST: 'ghost',
  LINK: 'link'
};

export const SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
};

export const FORM_ACTION_MIN_WIDTH = '89px';
